import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../pnp-settings-document-category.constants';
import { getDocumentCategory } from '../pnp-settings-document-category.actions';

class pnpSettingsDocumentCategoryGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope, $rootScope, AuthService) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'policies';
        this.identifier = IDS.pnpSettingsDocumentCategoryGrid;
        this.filterExpandButtonVisible = false;

        this.columns = [
            { title: '#', mapper: null },
            { title: 'Category Name', mapper: 'name' },
            { title: 'Head Office', mapper: 'head_office_name' },
            { title: 'Site Location', mapper: 'site_location_name' },
            { title: 'Department', mapper: 'department_name' },
            { title: 'Prefix Name', mapper: 'prefix'}
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getDocumentCategory }
        )(this);
        this.filter.identifier = this.identifier;
        this.dataAction = this.getDocumentCategory;
        this.exportService = this.getDocumentCategory;
        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

pnpSettingsDocumentCategoryGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope', '$rootScope'];

export const pnpSettingsDocumentCategoryGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
        onRemove: '&',
        onReset: '&'
    },
    controller: pnpSettingsDocumentCategoryGridController,
    ...gridTpl
}
